import { render, staticRenderFns } from "./TiersEdit.vue?vue&type=template&id=3bed4598&"
import script from "./TiersEdit.vue?vue&type=script&lang=js&"
export * from "./TiersEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports